<div class="personal-main-container">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">پکیج های شخصی</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div *ngIf="isReady && persoanlPackage && persoanlPackage.length == 0">
      <div class="empty-box">
        <img src="assets/general/emptypackage.svg" alt="" />
        <p class="titles">پکیج شما خالی است</p>
        <p class="descriptions">
          می‌توانید غذاهایی را که پرتکرار استفاده می‌کنید برای دسترسی سریع‌تر به
          پکیج ثابت اضافه کنید.
        </p>
      </div>
      <div class="custome-button" (click)="goCreatePackage()">
        <div class="add-icon-button">
          <img src="assets/plan/plus.svg" alt="" />
        </div>
        <p class="title">ساختن پکیج جدید</p>
      </div>
    </div>
    <div *ngIf="isReady && persoanlPackage && persoanlPackage.length > 0">
      <div
        class="food-list-item"
        *ngFor="let package of persoanlPackage; let last = last"
        [ngStyle]="{
          'border-bottom': last ? '0.2px solid rgba(0, 0, 0, 0.25)' : null
        }"
      >
        <div class="package-title">
          <div class="package-name">
            <span>پکیج</span>
            <span class="dividar"> | </span>
            {{ package.title }}
          </div>
          <p class="calorie">{{ getPackageCalorie(package.foods) }} کالری</p>
        </div>
        <div class="icons">
          <img
            src="assets/plans/plus.svg"
            (click)="addPersonalPackage(package)"
            class="plus"
            alt=""
          />
          <img
            src="assets/plans/edit.svg"
            (click)="goEditCreatePackage(package)"
            alt=""
          />
        </div>
      </div>
      <div class="add-button" (click)="goCreatePackage()">
        <div class="">
          <img src="assets/plan/plus-white.svg" alt="" />
          <p>ساختن پکیج جدید</p>
        </div>
      </div>
    </div>
    <div *ngIf="!isReady">
      <div class="loading-input" *ngFor="let i of gArr(6)">
        <ngx-skeleton-loader
          [theme]="{
            top: '21px',
            right: '16px',
            height: '20px',
            width: '87px',
            position: 'absolute',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [theme]="{
            top: '21px',
            left: '16px',
            height: '20px',
            width: '120px',
            position: 'absolute',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="add-button loading-button">
        <ngx-skeleton-loader
          [theme]="{
            height: '20px',
            width: '187px',
            'background-color': '#e8eaef'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
